"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONSUMER_APP_VERSION = exports.CONSUMER_APP_SEM_VERSION = exports.CONSUMER_UI_SETTING_PREFIX = exports.CONSUMER_APP_SOURCE = exports.StateMetaTypes = exports.ConsumerEventTypes = void 0;
exports.ConsumerEventTypes = Object.freeze({
    failure: 'FAILURE',
    submit: 'SUBMIT',
    dismiss: 'DISMISS',
    back: 'BACK',
    ssoInit: 'SSO_INIT',
    ssoSuccess: 'SSO_SUCCESS',
    redirect: 'REDIRECT',
    flowReady: 'FLOW_READY',
    flowTrigger: 'FLOW_TRIGGER',
    flowInsert: 'FLOW_INSERT',
    flowComplete: 'FLOW_COMPLETE',
    stateEnter: 'STATE_ENTER',
    close: 'CLOSE',
});
exports.StateMetaTypes = Object.freeze({
    inPage: 'inpage',
    fullPage: 'fullpage',
    modal: 'modal',
    external: 'external',
});
exports.CONSUMER_APP_SOURCE = 'upflowy-consumer-app';
exports.CONSUMER_UI_SETTING_PREFIX = 'data-uf-ui-';
/**
 * Current consumer app version (major, minor, patch)
 */
exports.CONSUMER_APP_SEM_VERSION = [2, 0, 0];
exports.CONSUMER_APP_VERSION = '2.0.0';
//# sourceMappingURL=constants.js.map